"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SzSearchBar = void 0;
var react_1 = __importStar(require("react"));
var SzInput_1 = __importDefault(require("../SzInput/SzInput"));
var SzButton_1 = __importDefault(require("../SzButton/SzButton"));
exports.SzSearchBar = function (_a) {
    var placeholder = _a.placeholder, handleClear = _a.handleClear, onClick = _a.onClick, icon = _a.icon, label = _a.label;
    var _b = __read(react_1.useState(''), 2), value = _b[0], setValue = _b[1];
    var handleChange = function (_a) {
        var target = _a.target;
        return setValue(target.value);
    };
    var handleClearValue = function () {
        handleClear && handleClear();
        setValue('');
    };
    var defaultButtonProps = {
        className: 'ml-3',
        isDisabled: value.length === 0,
        type: 'submit',
        onClick: function () { return onClick && onClick(value); }
    };
    return (react_1.default.createElement("div", { className: "d-inline-flex w-100" },
        react_1.default.createElement(SzInput_1.default, { placeholder: placeholder, value: value, onChange: handleChange, handleClear: handleClearValue, className: "border sz-border-1" }),
        icon && !label ? (react_1.default.createElement(SzButton_1.default, __assign({}, defaultButtonProps, { icon: "search" }))) : (react_1.default.createElement(SzButton_1.default, __assign({}, defaultButtonProps), label))));
};
exports.default = exports.SzSearchBar;
